export { default } from './MeuFinanciamentoConsulte';
